import { post } from "../../api/HttpClient.js";
import {
    BASE_URL, GetWeeklyCalendar_url, ZoneList_url, MakeBooking_url, CancelBooking_url, ReportParkingViolation_url
    , GetAlternateParkingSpot_url, CancelMeeting_url, DeclineMeeting_url, RescheduleMeeting_url, CheckInUser_url
    , BookingStatus_url, PostBookingQuestion_url, PostBookingAnswer_url, MapBasedBooking_apiBookingStatus_url
}
    from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";
import { getGuId, getFirstname, getEmailID, getLastname } from "../../utils/SecurityService.js";
export const GetWeeklyCalendar_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${GetWeeklyCalendar_url}`,
        params: requestParams,
    });
};

export const FetchZoneList_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${ZoneList_url}`,
        params: requestParams,
    });
};

export const MakeBooking_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.TeamLeaderGuId = getGuId();
    requestParams.FirstName = getFirstname();
    requestParams.EmailAddress = getEmailID();
    requestParams.LastName = getLastname();
    requestParams.TeamMemberGuId = "";
    requestParams.NationalId = "";
    requestParams.Tags = "";
    requestParams.IsGuest = 0;
    requestParams.FireStoreId = "";

    return post({
        url: `${BASE_URL}${MakeBooking_url}`,
        params: requestParams,
    });
};
export const CancelBooking_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.TeamLeaderGuId = getGuId();
    requestParams.TeamMemberGuId = "";
    requestParams.Language = AppConstant.Language;
    //requestParams.IsGuest = 0;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${CancelBooking_url}`,
        params: requestParams,
    });
};

export const ReportParkingViolation_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    return post({
        url: `${BASE_URL}${ReportParkingViolation_url}`,
        params: requestParams,
    });
};
export const GetAlternateParkingSpot_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    return post({
        url: `${BASE_URL}${GetAlternateParkingSpot_url}`,
        params: requestParams,
    });
};
export const CancelMeeting_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    return post({
        url: `${BASE_URL}${CancelMeeting_url}`,
        params: requestParams,
    });
};

export const DeclineMeeting_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    return post({
        url: `${BASE_URL}${DeclineMeeting_url}`,
        params: requestParams,
    });
};

export const RescheduleMeeting_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    return post({
        url: `${BASE_URL}${RescheduleMeeting_url}`,
        params: requestParams,
    });
};

export const CheckInUser_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.App = AppConstant.App;
    requestParams.Longitude = "";
    requestParams.Latitude = "";
    requestParams.ClaimFromFlag = 0;
    requestParams.ScanTime = 0;
    requestParams.CheckInType = 2;

    return post({
        url: `${BASE_URL}${CheckInUser_url}`,
        params: requestParams,
    });
};

export const BookingStatus_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    // requestParams.TeamMemberGuId = getGuId();

    return post({
        url: `${BASE_URL}${BookingStatus_url}`,
        params: requestParams,
    });
};

export const PostBookingQuestion_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;

    return post({
        url: `${BASE_URL}${PostBookingQuestion_url}`,
        params: requestParams,
    });
};

export const PostBookingAnswer_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    //requestParams.TeamMemberGuId = getGuId();
    requestParams.NotificationUniqueCode = "";
    requestParams.BookingPeriod = "1";

    return post({
        url: `${BASE_URL}${PostBookingAnswer_url}`,
        params: requestParams,
    });
};

export const MapBasedBooking_apiBookingStatus = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    // requestParams.TeamMemberGuId = getGuId();

    return post({
        url: `${BASE_URL}${MapBasedBooking_apiBookingStatus_url}`,
        params: requestParams,
    });
};
